import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/samplings'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        reportData(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/data`, data, { ...config, responseType: "blob" });
        }
    },
    mutations: {
        ...base.mutations
    },
}
